import { Box, Card, CardContent, Typography } from '@mui/material'
import { FunctionComponent } from 'react'

export const ValidationResultsStepCard: FunctionComponent<{
  value: number
  label: string
  color?: string | ((theme: any) => string)
}> = ({ value, label, color = 'text.primary' }) => {
  return (
    <Box sx={{ flex: '1 1 0', minWidth: 0 }}>
      <Card
        variant="outlined"
        sx={{
          p: 2,
          borderColor: 'lightGrey.main',
          borderRadius: 2,
          boxShadow: 'none'
        }}
      >
        <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 'bold',
              mb: 1,
              color
            }}
          >
            {(value || 0).toLocaleString()}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {label}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  )
}

